import styled, { css } from 'styled-components';
import Block from '@shared/components/ui/Block';

type ConstrainProps = {
    width?: 'extra-wide' | 'wide' | 'narrow' | 'narrow-mid' | 'tiny';
    fillHeight?: boolean;
    noPadding?: boolean;
};

const widthVariantStyles = (width: ConstrainProps['width'] = 'wide') =>
    ({
        'extra-wide': css`
            max-width: 1440px;
        `,
        wide: css`
            max-width: 1280px;
        `,
        narrow: css`
            max-width: 960px;
        `,
        'narrow-mid': css`
            max-width: 1100px;
        `,
        tiny: css`
            max-width: 680px;
        `,
    }[width]);

export const Constrain = styled(Block)<ConstrainProps>`
    margin: 0 auto;
    padding: 0 ${({ noPadding }) => !noPadding && '20px'};
    width: 100%;
    ${({ width }) => widthVariantStyles(width)};
    ${({ fillHeight }) => fillHeight && 'height: 100%;'};
`;
